<template>
  <v-snackbar
    v-model="visible"
    location="top end"
    :timeout="7000"
    class="ncrm-notification-toast"
  >
    <div
      class="notification-toast"
      role="button"
      tabindex="0"
      :aria-label="$t('ncrm.notifications.live.openSource')"
      @click="$emit('open', item)"
      @keydown.enter.prevent="$emit('open', item)"
      @keydown.space.prevent="$emit('open', item)"
    >
      <span class="notification-toast__icon">
        <v-icon size="21">{{ icon }}</v-icon>
      </span>
      <span class="notification-toast__body">
        <span class="notification-toast__eyebrow">
          {{ $t("ncrm.notifications.live.newNotification") }}
        </span>
        <strong>{{ headline }}</strong>
        <span>{{ $t("ncrm.notifications.live.openHint") }}</span>
      </span>
      <v-btn
        icon="mdi-close"
        variant="text"
        size="x-small"
        :aria-label="$t('ncrm.notifications.live.close')"
        @click.stop="visible = false"
      />
    </div>
  </v-snackbar>
</template>

<script>
import {
  notificationHeadline,
  notificationIcon,
} from "@/Utile/ncrmNotifications.mjs";

export default {
  name: "NcrmNotificationToast",
  props: {
    modelValue: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  emits: ["update:modelValue", "open"],
  computed: {
    visible: {
      get() {
        return this.modelValue && Boolean(this.item);
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    icon() {
      return notificationIcon(this.item?.eventType);
    },
    headline() {
      return notificationHeadline(this.item || {}, (key, params) => this.$t(key, params));
    },
  },
};
</script>

<style scoped>
.ncrm-notification-toast :deep(.v-snackbar__wrapper) {
  min-width: min(390px, calc(100vw - 32px));
  max-width: min(390px, calc(100vw - 32px));
  padding: 0;
  color: var(--app-text-strong);
  background: var(--app-content-background);
  border-radius: var(--app-radius-base);
  box-shadow: 0 10px 30px rgba(var(--v-theme-on-surface), 0.18);
}

.ncrm-notification-toast :deep(.v-snackbar__content) {
  padding: 0;
}

.notification-toast {
  width: 100%;
  min-height: 96px;
  padding: 14px;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 30px;
  align-items: center;
  gap: 11px;
  color: inherit;
  background: transparent;
  border: 0;
  border-left: 4px solid rgb(var(--v-theme-error));
  border-radius: var(--app-radius-base);
  cursor: pointer;
  text-align: left;
}

.notification-toast:focus-visible {
  outline: 2px solid rgba(var(--v-theme-primary), 0.35);
  outline-offset: 2px;
}

.notification-toast__icon {
  width: 38px;
  height: 38px;
  border-radius: var(--app-radius-base);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.1);
}

.notification-toast__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.notification-toast__eyebrow {
  color: rgb(var(--v-theme-error));
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.notification-toast__body strong {
  overflow: hidden;
  color: var(--app-text-strong);
  font-size: 0.9rem;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.notification-toast__body > span:last-child {
  color: var(--app-text-muted);
  font-size: 0.76rem;
}
</style>
